import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>Image Gallery — Week 7</p>
    </footer>
  );
}

export default Footer;
